module.exports = __webpack_public_path__ + "img/1015.075ec40f.jpg";